import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=b13cb648&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=b13cb648&prod&lang=less&scoped=true"
import style1 from "./Banner.vue?vue&type=style&index=1&id=b13cb648&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13cb648",
  null
  
)

export default component.exports